import { render, staticRenderFns } from "./PrepaidPackagePaymentNotification.vue?vue&type=template&id=634a37a0&scoped=true&"
import script from "./PrepaidPackagePaymentNotification.vue?vue&type=script&lang=js&"
export * from "./PrepaidPackagePaymentNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a37a0",
  null
  
)

export default component.exports